import React, {Fragment, useContext, useEffect, useState} from "react";
import {ServerContext} from "../../serverContext/ServerProvider";
import {Loader} from "../../components/Loader";
import {Text} from "../../components/inputs/Text";
import {List} from "../../components/inputs/List";
import {NotificatorContext} from "../../components/Notificator";

export const Buy = ({good}) => {
    const {getBuy, buy, updateBuy} = useContext(ServerContext)
    const {showNotification} = useContext(NotificatorContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function wtf() {
            await getBuy(good.buy, () => setLoading(false))
        }

        wtf()
    }, [])

    useEffect(() => {
        if (!loading && buy) {
            init()
        }
    }, [buy, loading])

    const [amounts, setAmounts] = useState([])
    const [titles, setTitles] = useState([])
    const [options, setOptions] = useState([])


    const init = () => {
        buy.map(buy => {
            setTitles(prev => prev.concat([buy.title]))
            setAmounts(prev => prev.concat([buy.amount]))
            setOptions(prev => prev.concat([buy.options]))
            return buy
        })
    }

    const setTitle = (newValue, {index}) => {
        setTitles(prev => prev.map((value, i) => {
            if (i === index) {
                return newValue
            }
            return value
        }))
    }

    const setAmount = (newValue, {index}) => {
        setAmounts(prev => prev.map((value, i) => {
            if (i === index) {
                return newValue
            }
            return value
        }))
    }

    const handleOptions = (newValue, index, {optionIndex}) => {
        setOptions(options.map((params, i) => {
            if (i === optionIndex) {
                return params.map((param, j) => {
                    if (j === index) {
                        return newValue
                    }
                    return param
                })
            }
            return params
        }))
    }

    const save = () => {
        const toSave = {
            options: titles.map((title, index) => {
                return {
                    title,
                    options: options[index],
                    amount: amounts[index]
                }
            })
        }
        updateBuy(good.buy, toSave, () => showNotification('Changes have been saved on server'))
    }

    const addSpec = ({optionIndex}) => {
        setOptions(prev => prev.map((options, index) => {
            if (index === optionIndex) {
                return options.concat([' '])
            }
            return options
        }))
    }

    const removeSpec = (index, {optionIndex}) => {
        setOptions(prev => prev.map((options, i) => {
            if (i === optionIndex) {
                return options.filter((d, j) => j !== index)
            }
            return options
        }))
    }

    return (
        <Fragment>
            {loading ? <Loader/> : (
                <Fragment>
                    <div className='container pl-0 pt-5 editor_container'>
                        {titles.map((title, index) => (
                            <div key={index} className='editor_subcontainer'>
                                <div className="row mb-5 mt-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Title:</div>
                                    <div className="col-8 text-muted pt-1 pb-1">
                                        <Text
                                            state={title}
                                            setState={setTitle}
                                            setterArgs={{index}}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-5 mt-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Amount:</div>
                                    <div className="col-8 text-muted pt-1 pb-1">
                                        <Text
                                            state={amounts[index]}
                                            setState={setAmount}
                                            setterArgs={{index}}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-5 mt-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Specs:</div>
                                    <div className="col-8 text-muted pt-1 pb-1">
                                        <List
                                            state={options[index]}
                                            handler={handleOptions}
                                            addHandler={addSpec}
                                            removeHandler={removeSpec}
                                            args={{optionIndex: index}}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className='save_button float-right' onClick={save}>Save</button>
                </Fragment>
            )}
        </Fragment>
    )
}